import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Bill from '../seat/Bill';
import HowPayDialog from '../seat/HowPayDialog';
import { fetchDefault, getNowTimeStamp } from '../Utils.js';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import InputAdornment from '@material-ui/core/InputAdornment';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import LocalGroceryStoreIcon from '@material-ui/icons/LocalGroceryStore';

const amountList = [
    {
        value: 1,
        label: '1개',
    },
    {
        value: 2,
        label: '2개',
    },
    {
        value: 3,
        label: '3개',
    },
    {
        value: 4,
        label: '4개',
    },
    {
        value: 5,
        label: '5개',
    },
    {
        value: 6,
        label: '6개',
    },
    {
        value: 7,
        label: '7개',
    },
    {
        value: 8,
        label: '8개',
    },
    {
        value: 9,
        label: '9개',
    },
    {
        value: 10,
        label: '10개',
    },
    {
        value: 11,
        label: '11개',
    },
    {
        value: 12,
        label: '12개',
    },
    {
        value: 13,
        label: '13개',
    },
    {
        value: 14,
        label: '14개',
    },
    {
        value: 15,
        label: '15개',
    },
];

const useStyles = makeStyles(theme => ({
    paper: {
        width: '100%',
        marginTop: 1,
        overflowX: 'auto',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 280,
    },
    menu: {
        width: 180,
    },
}));

export default function Showcase2() {
    const classes = useStyles();

    const [loginId, setLoginId] = React.useState('');
    const [password, setPassword] = React.useState('');

    const [amount, setAmount] = React.useState(3);
        
    const [originalPrice, setOriginalPricet] = React.useState();
    const [memberDiscount, setMemberDiscount] = React.useState();
    const [doubleDiscount, setDoubleDiscount] = React.useState();
    const [usePoint, setUsePoint] = React.useState();
    const [myPoint, setMyPoint] = React.useState();
    const [totalPrice, setTotalPrice] = React.useState();

    //Validate
    const [memberIdErrorText, setMemberIdErrorText] = React.useState('');
    const [passwordErrorText, setPasswordErrorText] = React.useState('');

    const validateMemberId = (event) => {
        if (event.target.value.length < 1) {
            setMemberIdErrorText('아이디를 입력해주세요.');
            return;
        } else {
            setMemberIdErrorText('');
        }


    };

    const validatePassword = (event) => {
        setPassword(event.target.value);

        //패스워드 확인 부분
        if (event.target.value.length < 1) {
            setPasswordErrorText('비밀번호를 입력해주세요.');
        }
        else {
            setPasswordErrorText('');
        }

        //계산
        setBill(amount, loginId, event.target.value);

    };
    
    const onAmountChange = event => {
        setAmount(event.target.value);
        setBill(event.target.value, loginId, password);
    };

    useEffect(() => {

        //계산
        setBill(amount, loginId, password);

        return () => {
        }
    }, []);

    const setBill = (amount, loginId, password) => {
        fetchDefault('/Payment/GetSnackBill?displayId=2&amount=' + amount + '&loginId=' + loginId + '&password=' + password,
            (data) => {
                setOriginalPricet(data.originalPrice);
                setMemberDiscount(data.memberDiscount);
                setDoubleDiscount(data.doubleDiscount);
                setUsePoint(data.usePoint);
                setTotalPrice(data.totalPrice);
                setMyPoint(data.myPoint);
            }
        );

    }

    return (
        <div className={classes.root}>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <Typography variant="h4" style={{ marginTop: 50, marginBottom:30 }}>모든 상품은 <strong>"개당 600원"</strong> 입니다.</Typography>
                </Grid>
                <Grid item xs={12}>
                    <Card>
                        <CardContent>
                            <Typography variant="h6">아래 항목에 따라 결제 후 선택하신 개수만큼 원하시는 상품을 수령해주세요.</Typography>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="h6">
                        1. 아이디, 비밀번호를 입력해주세요.
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        onBlur={validateMemberId}
                        onChange={(event) => setLoginId(event.target.value)}
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="loginId"
                        label="아이디"
                        name="loginId"
                        error={memberIdErrorText.length === 0 ? false : true}
                        helperText={memberIdErrorText}
                    />
                    <TextField
                        onChange={(event) => validatePassword(event)}
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        name="password"
                        label="비밀번호"
                        type="password"
                        id="password"
                        error={passwordErrorText.length === 0 ? false : true}
                        helperText={passwordErrorText}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="h6">
                        2. 구입하실 상품 개수를 선택해주세요.
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        id="outlined-select-currency"
                        select
                        label="Select"
                        className={classes.textField}
                        value={amount}
                        onChange={onAmountChange}
                        SelectProps={{
                            MenuProps: {
                                className: classes.menu,
                            },
                        }}
                        margin="normal"
                        variant="outlined"
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <LocalGroceryStoreIcon />
                                </InputAdornment>
                            ),
                        }}
                    >
                        {amountList.map(option => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="h6">
                        3. 결제를 진행해주세요.
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Bill isSnack='true' originalPrice={originalPrice} memberDiscount={memberDiscount} doubleDiscount={doubleDiscount} usePoint={usePoint} myPoint={myPoint} totalPrice={totalPrice} />
                </Grid>
                <Grid item xs={12}>
                    <HowPayDialog isSnack='true' homeUrl='/showcase2' usePoint={usePoint} totalPrice={totalPrice} controllerUrl={'/Payment/PaySnack?displayId=2&amount=' + amount + '&loginId=' + loginId + '&password=' + password} loginId={loginId} password={password} />
                </Grid>
            </Grid>

        </div>
    );

}



// WEBPACK FOOTER //
// ./src/components/snack/Showcase2.js